import { styled } from 'styled-components';
/** As we transition to Tailwind, we need to continue to support Styled-Components and style embedding */
export const styledBackwardsCompatibility = (Component) => styled(Component) ``;
//# sourceMappingURL=styled-backwards-compatibility.js.map